import React from "react";
import { useParams } from "react-router-dom";
import { courseCategories } from "../data";
import { getCourseImage } from "../config/courseImages";
import { Container, Typography } from "../components/ui";
import Footer from "../views/Footer";

const CourseDetail = () => {
  const { slug } = useParams();

  // Find course
  const course = courseCategories
    .flatMap(cat => cat.courses)
    .find(
      c => c.title.toLowerCase().replace(/\s+/g, "-") === slug
    );

  if (!course) {
    return <div className="p-10 text-center">Course not found</div>;
  }

  return (
    <>
      <Container.Section padding="content" background="white">
        <Container size="standard">

          <div className="max-w-4xl mx-auto">

            {/* Title */}
            <Typography.H2 className="mb-4">
              {course.title}
            </Typography.H2>

            {/* Image */}
            <img
              src={getCourseImage(course.title)}
              alt={course.title}
              className="w-full h-64 object-cover rounded-lg mb-6"
            />

            {/* Description */}
            <div 
              className="text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ 
                __html: (course.fullDescription || course.description).replace(/\n/g, '<br/>') 
              }}
            />

          </div>

        </Container>
      </Container.Section>

      <Footer />
    </>
  );
};

export default CourseDetail;